import { PaymentMethodIcon } from '@change/ds-core-ui';
import { GovBuildingIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import type { PaymentType } from 'src/app/shared/utils/payments';

import type { SavedPaymentMethodContent } from '../types';

import { getIconVariant } from './getIconVariant';

type Content = {
	icon: React.ReactNode;
	label: string;
	details?: string;
};

const mapPaymentMethodTypeToLabel = (type: PaymentType) => {
	if (type === 'applePay') {
		return 'Apple Pay';
	}
	if (type === 'googlePay') {
		return 'Google Pay';
	}
	if (type === 'paypal') {
		return 'PayPal';
	}
	return '';
};

type Variant = 'variant_1' | 'variant_2';

type Params = {
	paymentMethod: SavedPaymentMethodContent;
	variant?: Variant;
	index?: number;
};

export function getContent({ paymentMethod, variant = 'variant_1', index = 0 }: Params): Content {
	if (paymentMethod.type === 'creditCard') {
		return {
			icon: (
				<PaymentMethodIcon
					type={getIconVariant(paymentMethod)}
					variant="card"
					className={cn('bg-background-base h-7.5 w-10', { 'h-9 w-12': variant === 'variant_2' })}
					svgClassName={cn({ 'h-9 w-9': variant === 'variant_2' })}
				/>
			),
			label: variant === 'variant_1' ? 'Saved card' : `•••• ${paymentMethod.detail}`, // TODO: add translation when productized
			details: `•••• ${paymentMethod.detail}`,
		};
	}
	if (paymentMethod.type === 'sepa') {
		return {
			icon: (
				<div
					className={cn(
						'border-stroke-weaker bg-background-base flex h-7.5 w-10 items-center justify-center rounded-xs border',
						{ 'h-9 w-12': variant === 'variant_2' },
					)}
				>
					<GovBuildingIcon className="h-5 w-5" />
				</div>
			),
			label: `Checking •••• ${paymentMethod.detail}`, // TODO: add translation when productized
		};
	}
	return {
		icon: (
			<PaymentMethodIcon
				type={getIconVariant(paymentMethod)}
				variant="card"
				className={cn('bg-background-base h-7.5 w-10', {
					'h-9 w-12': variant === 'variant_2',
					'rounded-small! border-[1.5px]! border-black': paymentMethod.type === 'applePay',
				})}
				svgClassName={cn({ 'h-9 w-9': variant === 'variant_2' })}
			/>
		),
		label: mapPaymentMethodTypeToLabel(paymentMethod.type),
		details:
			index === 0 && (paymentMethod.type === 'applePay' || paymentMethod.type === 'googlePay')
				? // TODO: add translation when productized
					'Last used'
				: undefined,
	};
}
